module.exports = __webpack_public_path__ + "img/logo.c665cf37.svg";